<template>
  <div>
    <b-breadcrumb class="breadcrumb">
      <b-breadcrumb-item href="/">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首页
      </b-breadcrumb-item>
      <b-breadcrumb-item href="/search-job"> 岗位列表 </b-breadcrumb-item>
      <b-breadcrumb-item active>岗位详情</b-breadcrumb-item>
    </b-breadcrumb>

    <el-alert
      title="警示每一位求职者：若用人单位存在提供虚假招聘信息、发布虚假招聘广告，以担保或者其他任何名义向求职者收取财物（如办卡费、押金、培训费），扣押或以保管为名索要身份证、毕业证及其他证件等行为，均涉嫌违法，请您提高警惕并注意保护个人信息。"
      type="error"
      show-icon
      :closable="false"
    >
    </el-alert>
    <b-jumbotron header-tag="div" header-level="5" lead-tag="div">
      <template v-slot:header>
        <b-row class="mb-1" align-h="start">
          <b-col cols="7" class="job-name text-truncate text-left">
            <h4>{{ job.jobName }}</h4>
          </b-col>
          <b-col class="font-22 text-danger text-truncate font-weight-bold text-right">￥{{ job.salaryRange }}</b-col>
        </b-row>
      </template>

      <template v-slot:lead>
        <div class="font-18">
          <b-link :to="'/show-comp/' + job.compId" target="_blank" class="news-list">{{ job.compName }}</b-link>
        </div>
      </template>

      <b-row class="mt-2">
        <b-col cols="3">
          <label class="font-16 text-muted">工作经验要求：</label>
          <label class="font-16 text-muted">{{ job.workYear }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">学历要求：</label>
          <label class="font-16 text-muted">{{ job.education }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">工作环境：</label>
          <label class="font-16 text-muted">{{ job.workEnvi }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">工作模式：</label>
          <label class="font-16 text-muted">{{ job.workMode }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">左眼视力要求：</label>
          <label class="font-16 text-muted">{{ job.leftEye }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">右眼视力要求：</label>
          <label class="font-16 text-muted">{{ job.rightEye }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">政治面貌要求：</label>
          <label class="font-16 text-muted">{{ job.policy }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">身高要求：</label>
          <label class="font-16 text-muted">{{ job.height }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">体重要求：</label>
          <label class="font-16 text-muted">{{ job.weight }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">餐饮条件：</label>
          <label class="font-16 text-muted">{{ job.catered }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">性别要求：</label>
          <label class="font-16 text-muted">{{ job.sex }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">是否五天制工作：</label>
          <label class="font-16 text-muted">{{ job.fiveDay }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">是否存在倒班工作：</label>
          <label class="font-16 text-muted">{{ job.shiftWork }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否较多加班：</label>
          <label class="font-16 text-muted">{{ job.moreOvertime }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否签订正式劳务合同：</label>
          <label class="font-16 text-muted">{{ job.laborContract }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">是否缴纳五险一金：</label>
          <label class="font-16 text-muted">{{ job.socialInsurance }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">是否需要计算机等级技能：</label>
          <label class="font-16 text-muted">{{ job.computer }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否需要外语技能：</label>
          <label class="font-16 text-muted">{{ job.foreign }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否需要持有驾照：</label>
          <label class="font-16 text-muted">{{ job.driver }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">是否需要具备执业资格证：</label>
          <label class="font-16 text-muted">{{ job.certificate }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">是否提供住宿：</label>
          <label class="font-16 text-muted">{{ job.accommodation }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否提供租房协助：</label>
          <label class="font-16 text-muted">{{ job.renting }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否具有单位食堂：</label>
          <label class="font-16 text-muted">{{ job.canteen }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">是否接受色盲：</label>
          <label class="font-16 text-muted">{{ job.color }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label class="font-16 text-muted">是否接受身体残疾：</label>
          <label class="font-16 text-muted">{{ job.disability }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否接受少数民族：</label>
          <label class="font-16 text-muted">{{ job.minority }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">是否优先接受贫困家庭学生：</label>
          <label class="font-16 text-muted">{{ job.poor }}</label>
        </b-col>
        <b-col>
          <label class="font-16 text-muted">是否优先接受特困家庭学生：</label>
          <label class="font-16 text-muted">{{ job.poorest }}</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label class="font-16 text-muted">工作地址：</label>
          <label class="font-16 text-muted">{{ job.workAddr }}</label>
        </b-col>
        <b-col cols="3">
          <label class="font-16 text-muted">拟招聘人数：</label>
          <label class="font-16 text-muted">{{ job.headcount }}人</label>
        </b-col>
      </b-row>

      <div class="text-right">
        <b-button :href="$ADMIN_URL" target="admin_window" variant="primary">投递简历</b-button>
      </div>
    </b-jumbotron>

    <b-row>
      <b-col>
        <b-card header="招聘详情">
          <div class="content-font" v-html="job.jobDesc"></div>
        </b-card>

        <b-card header="企业简介">
          <div class="content-font" v-html="job.compDesc"></div>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card header="企业信息" footer-bg-variant="white" footer-class="otherInfoCard">
          <b-row>
            <b-col cols="3">
              <b-img :src="job.compLogo" alt="Image 1" width="50" height="50"></b-img>
            </b-col>
            <b-col class="pr-0">
              <div class="font-18">
                <b-link :to="'/show-comp/' + job.compId" target="_blank" class="news-list">{{ job.compName }}</b-link>
              </div>
            </b-col>
          </b-row>

          <div class="font-14 text-muted mt-2"><b-icon icon="info-square-fill" variant="secondary " scale="4" class="font-weight-bold pr-2 tag-height"></b-icon>{{ job.compBizType }}</div>
          <div class="font-14 text-muted mt-2"><b-icon icon="flag-fill" variant="secondary " scale="4" class="font-weight-bold pr-2 tag-height"></b-icon>{{ job.compBizSize }}</div>
          <div class="font-14 text-muted mt-2"><b-icon icon="grid-fill" variant="secondary " scale="4" class="font-weight-bold pr-2 tag-height"></b-icon>{{ job.compBizIndustry }}</div>
          <div class="font-14 text-muted mt-2"><b-icon icon="star-fill" variant="secondary " scale="4" class="font-weight-bold pr-2 tag-height"></b-icon>{{ job.compRegMoney }}万元</div>
          <div class="font-14 text-muted mt-2"><b-icon icon="shield-lock-fill" variant="secondary " scale="4" class="font-weight-bold pr-2 tag-height text-left"></b-icon>{{ job.compRegAddr }}</div>

          <template v-slot:footer v-if="otherJobList.length > 0">
            <div class="font-14"><b-icon rotate="180" icon="triangle-fill" variant="secondary" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon>该企业其它招聘岗位</div>
            <b-list-group flush>
              <b-list-group-item class="otherJob content-font" v-for="(item, index) in otherJobList" :key="index">
                <b-row>
                  <b-col>
                    <div class="content-font">
                      ■ <b-link :to="'/show-job/' + item.jobRecruitmentId" target="_self" class="news-list">{{ item.jobName }}</b-link>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="pl-0 text-danger">￥{{ item.salaryRangeName }}</div>
                  </b-col>
                  <b-col cols="5">
                    <div class="content-font">人数：{{ item.headcount }}人</div>
                  </b-col>
                </b-row>
              </b-list-group-item>

              <b-list-group-item class="otherJob content-font text-right">
                <b-link :to="'/show-comp/' + job.compId" target="_blank" class="news-list">更多招聘岗位</b-link>
              </b-list-group-item>
            </b-list-group>
          </template>
        </b-card>

        <b-jumbotron header-tag="div" header-level="5" lead-tag="div" class="mt-2">
          <b-icon icon="bell-fill" variant="danger" scale="3" class="font-weight-bold pr-2 tag-height"></b-icon><label class="text-danger">求职防骗局</label>
        </b-jumbotron>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ShowJob',
  data() {
    return {
      jobId: undefined,
      job: {},
      otherJobList: []
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        window.scrollTo(0, 0)
        this.jobId = to.params.id
        this.fetchData()
      }
    }
  },
  created() {
    this.jobId = this.$route.params.id
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    /**
     * 获取岗位详情
     */
    fetchData() {
      const that = this
      const postData = {
        id: that.jobId
      }
      that
        .$http({
          method: 'post',
          url: '/portal/job-info',
          data: postData
        })
        .then((d) => {
          that.job = d
          that.fetchOtherJobList()
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取岗位详情失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取不包含当前招聘岗位的当前企业下的其它招聘岗位列表
     */
    fetchOtherJobList() {
      const that = this
      const postData = {
        pageNo: 1,
        pageSize: 10,
        compId: that.job.compId,
        jobId: that.jobId,
        workModeId: null,
        educationId: null,
        workEnviId: null,
        jobName: null
      }
      that
        .$http({
          method: 'post',
          url: '/portal/other-job-page-by-comp-id',
          data: postData
        })
        .then((d) => {
          that.otherJobList = d.records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取不包含当前招聘岗位的当前企业下的其它招聘岗位列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
  .jumbotron {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.font-22 {
  font-size: 22px;
}
.font-18 {
  font-size: 18px;
}
.font-16 {
  font-size: 16px;
}
.font-14 {
  font-size: 14px;
}
.otherInfoCard {
  padding: 10px;
}
.otherJob {
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
